import { Component, Input, ElementRef, ViewChild } from '@angular/core';
import { Playback, Media, PlaybackSession } from '../playback';
import { PlayerService } from '../player/player.service';
import { BaseComponent, Logger } from '@tytapp/common';
import { AvAsset } from 'models';

@Component({
  selector: 'tyt-media-preview',
  templateUrl: './media-preview.component.html',
  styleUrls: ['./media-preview.component.scss']
})
export class MediaPreviewComponent extends BaseComponent {

  constructor(
    private playbackService : Playback,
    private playerService : PlayerService,
    private element : ElementRef
  ) { 
    super();
  }

  @ViewChild('root', { static: true }) 
  rootElement : ElementRef;

  @Input() 
  source : AvAsset;

  private session : PlaybackSession;

  async init() {
    if (typeof window === 'undefined')
      return; 
      
    if (!this.source || this.playerService.media)
      return;

    this.subscribe(this.playerService.mediaChange, () => {
      if (!this.session)
        return;

      this.session.pause();
      this.session.destroy();
      this.session = null;
    });

    let resolution = this.playbackService.resolve({
      type: "video",
      item: <any>{
        asset: this.source
      }
    });

    if (!resolution)
      return;
    
    try {
      this.session = await resolution.service.play(resolution, this.rootElement, { startPosition: 0 });
    } catch (e) {
      Logger.error(`Failed to preview stream at URL ${this.source}`, e);
      return;
    }

    this.session.setVolume(0);
    this.session.resume();
  }

}
